import { AfterViewInit, ChangeDetectorRef, Component, ContentChild, ElementRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { WindowEventsService } from '@app/core/services/window-events/window-events.service';

@Component({
  selector: 'ess-experience-insiders-gallery',
  templateUrl: './experience-insiders-gallery.component.html',
  styleUrls: ['./experience-insiders-gallery.component.scss'],
  standalone: false,
})
export class ExperienceInsidersGalleryComponent implements AfterViewInit {
  @ContentChild('gallery') galleryRef: ElementRef | null = null;
  @ViewChild('stickyContainer') stickyContainerRef: ElementRef | null = null;

  DESKTOP_BREAKPOINT_HD = 1600;
  MAX_WIDTH = 0.9; // %
  MAX_WIDTH_HD = 1400;
  scrollableHeight$: Observable<number> | null = null;
  translate$: Observable<number> | null = null;

  constructor(
    private windowEventsService: WindowEventsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    if (this.galleryRef && this.galleryRef.nativeElement?.children?.length > 1 && this.stickyContainerRef) {
      this.applyScrollListener(this.stickyContainerRef);
      this.applyResizeListener();
      this.changeDetectorRef.detectChanges();
    }
  }

  calculateDynamicHeight(elementWidth: number): number {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const scrollBarWidth = vw - document.documentElement.clientWidth;
    return elementWidth - vw + vh + scrollBarWidth + this.calculateMargin(vw, scrollBarWidth);
  }

  calculateMargin(vw: number, scrollBarWidth: number): number {
    let margin = 0;
    if (vw > this.DESKTOP_BREAKPOINT_HD) {
      margin = (vw - this.MAX_WIDTH_HD - scrollBarWidth) / 2;
    } else {
      margin = ((vw - scrollBarWidth) * (1 - this.MAX_WIDTH)) / 2;
    }

    return +margin.toFixed(2);
  }

  applyScrollListener(ref: ElementRef): void {
    const element = ref.nativeElement;
    this.translate$ = this.windowEventsService.scrollListener$.pipe(map(() => -element.offsetTop));
  }

  applyResizeListener(): void {
    this.scrollableHeight$ = this.windowEventsService.resizeListener$.pipe(
      startWith(''),
      map(() => this.calculateDynamicHeight(this.galleryRef?.nativeElement.scrollWidth)),
    );
  }
}
